import { defineAsyncComponent, type Component } from 'vue'

// Async so a page only loads the variant it shows: the dropdown variant pulls in radix-vue.
export const stickyBarVariantMap = {
  dropdownStickyBar: defineAsyncComponent(() => import('@corporate/components/blocks/StickyBar/DropdownStickyBar.vue')),
  kinderopvangStickyBar: defineAsyncComponent(
    () => import('@corporate/components/blocks/StickyBar/LocationSearchStickyBar.vue'),
  ),
  contentStickyBar: defineAsyncComponent(() => import('@corporate/components/blocks/StickyBar/ContentStickyBar.vue')),
} as const

export type StickyBarVariantKey = keyof typeof stickyBarVariantMap

export function resolveStickyBarVariant(stickyType: string | undefined): Component | undefined {
  if (!stickyType) return undefined
  return stickyBarVariantMap[stickyType as StickyBarVariantKey]
}
